import { useMDPModalContext } from 'contexts/MDPModal';
import React, { FC, useEffect } from 'react';
import { replaceRedirectionLinkRoot } from 'utils/helpers/replaceRedirectionLinkRoot';

import GeneralDisclaimer, { CallToAction } from '../GeneralDisclaimer';

// VDPWrapper ------
export type Props = {
  body2?: Queries.ContentfulSection001Body;
  body: Queries.ContentfulSection001Body;
  callToAction: CallToAction;
  metadata?: Queries.ContentfulMetadata001;
  onModalStateUpdate?: (isOpen: boolean) => void;
  title: string;
};
const MDPModalWrapper: FC<Props> = (props) => {
  const {
    customUrl,
    isMDPModalAvailable,
    open,
    openHandler,
    setIsMDPModalAvailable,
  } = useMDPModalContext();
  const { body, body2, title, callToAction, onModalStateUpdate } = props;

  if (!isMDPModalAvailable) {
    setIsMDPModalAvailable(true);
  }

  useEffect(() => {
    if (onModalStateUpdate) {
      onModalStateUpdate(open);
    }
  }, [open, onModalStateUpdate]);

  return (
    <GeneralDisclaimer
      open={open}
      openHandler={openHandler}
      body={body}
      body2={body2}
      callToAction={{
        ...callToAction,
        // This replaces the root of the redirection link. To make sure it redirects to the correct environment
        url: replaceRedirectionLinkRoot(customUrl || props.callToAction.url),
      }}
      title={title}
    />
  );
};

// Export ---------

export default MDPModalWrapper;
